export const languageOpts = [
  {
    language: "Latvian",
    //heading
    pdfInvoice: "Pavadzīme",
    pdfProforma: "Priekšapmaksas rēķins",
    creationDataLabel: "Izsniegšanas Datums:",
    numberLabelInvoice: "Pavadzīmes numurs:",
    numberLabelProforma: "Rēķina numurs:",
    // data
    mSenderLabel: "Sūtītājs",
    mNameLabel: "Uzņēmums :",
    mRegNumberLabel: "Reģ. Numurs :",
    mVatNumberLabel: "PVN Numurs :",
    companyAddressLabel: "Juridiskā Adrese :",
    deliveryAddressLabel: "Izsniegšanas vietas adrese :",
    //bank details
    bankMainLabel: "Bankas Informācija",
    bankNameLabel: "Banka :",
    accountNumberLabel: "Konta Nr. :",
    bankCodeLabel: "Bankas Kods :",
    //client data
    cReceiverLabel: "Saņēmējs",
    cNameLabel: "Uzņēmums :",
    cRegNumberLabel: "Reģ. Numurs :",
    cVatNumberLabel: "PVN Numurs :",
    clientsCompanyAddressLabel: "Juridiskā Adrese :",
    clientsDeliveryAddressLabel: "Saņemšanas vietas adrese :",
    //clients bank details
    clientsBankMainLabel: "Bankas Informācija",
    clientsBankNameLabel: "Banka :",
    clientsAccountNumberLabel: "Konta Nr. :",
    clientsBankCodeLabel: "Bankas Kods :",
    //price data
    priceCodeHeaderLabel: "Kods",
    priceNameHeaderLabel: "Produkts",
    priceUnitLabel: "Mērv.",
    priceCountLabel: "Daudz.",
    priceLabel: "Cena",
    priceSumLabel: "Sum.",
    //price
    priceUnit: "tūkst.",
    pcsString: "gab.",
    totalSumLabel: "Kopējā summa EUR :",
    vatTotalLabel: "Nodoklis (21%) :",
    totalAmountLabel: "Kopā EUR (ieskaitot nodokli) :",
    discountLabel: "Atlaide EUR :",
    //issuer
    issuerNameAndSurname: "Vārds un uzvārds :",
    signature: "Paraksts :",
    issueDate: "Izsniegšanas datums :",
    issueYear: "20",
    issueYearLabel: "gada",
    //recipient
    recipientNameAndSurname: "Vārds un uzvārds :",
    recipientDate: "Saņemšanas datums :",
    rSignature: "Paraksts :",
    recipientYear: "20",
    recipientYearLabel: "gada",
    payUntilLabel: "Apmaksāt līdz :",
    commentLabel: "Piezīmes :",
    //plate
    newPlateName: "Jaunas plates izgatavošana",
    //label for sum with words
    sumWithWordsLabel: "Atmaksas summa vārdiem :",
    advancePaymentSumLabel: "Apmaksātā avansa summa :",
    advancePaymentVatLabel: "PVN (21%) :",
    leftPaymentSum: "Atlikusī summa EUR :",
    proformaRefLabel: "Balstoties uz dokumentu ",
    proformaRefLabelMany: "Balstoties uz dokumentiem ",
    paymentDocumentText: "Veicot apmaksu, lūdzam norādīt dokumenta numurs:",

    creditInvoiceRefLabel: "Kredīts rēķinam:",
    originalInvoiceAmountLabel: "Oriģinālā rēķina summa:",
    creditAmountLabel: "Kredīta summa:",
    balanceAmountLabel: "Atlikums:",
    discountName: "Atlaide",
    surchargeName: "Piemaksa",
    discountLabel: "Atlaide/Piemaksa:",
    subtotalLabel: "Summa Pirms:",
    discountName: "Atlaide",
    surchargeName: "Piemaksa",
  },
  {
    language: "English",
    //heading
    pdfInvoice: "Invoice",
    pdfProforma: "Proforma",
    creationDataLabel: "Creation Date:",
    numberLabelInvoice: "Invoice number:",
    numberLabelProforma: "Proforma number:",
    //data
    mSenderLabel: "Sender",
    mNameLabel: "Company :",
    mRegNumberLabel: "REG Number :",
    mVatNumberLabel: "Tax Number :",
    companyAddressLabel: "Company address :",
    deliveryAddressLabel: "Delivery address:",
    //bank details
    bankMainLabel: "Bank Information",
    bankNameLabel: "Bank Name :",
    accountNumberLabel: "Account Nr. :",
    bankCodeLabel: "Bank Code :",
    //client data
    cReceiverLabel: "Receiver",
    cNameLabel: "Company :",
    cRegNumberLabel: "REG Number :",
    cVatNumberLabel: "Tax Number :",
    clientsCompanyAddressLabel: "Company address :",
    clientsDeliveryAddressLabel: "Delivery address:",
    //clients bank details
    clientsBankMainLabel: "Bank Information",
    clientsBankNameLabel: "Bank Name :",
    clientsAccountNumberLabel: "Account Nr. :",
    clientsBankCodeLabel: "Bank Code :",
    //price header data
    priceCodeHeaderLabel: "Code",
    priceNameHeaderLabel: "Product",
    priceUnitLabel: "Unit",
    priceCountLabel: "Count",
    priceLabel: "Price",
    priceSumLabel: "Sum",
    discountLabel: "Discount EUR :",
    //price
    priceUnit: "thous.",
    pcsString: "pcs.",
    totalSumLabel: "Total Sum EUR :",
    vatTotalLabel: "Tax Amount (21%) :",
    totalAmountLabel: "Total Amount EUR (incl.Tax) :",
    //issuer
    issuerNameAndSurname: "Name and surname :",
    signature: "Signature :",
    issueDate: "Issue date :",
    issueYear: "20",
    issueYearLabel: "year",
    //recipient
    recipientNameAndSurname: "Name and surname :",
    rSignature: "Signature :",
    recipientDate: "Date of receipt :",
    recipientYear: "20",
    recipientYearLabel: "year",
    payUntilLabel: "Pay Until :",
    commentLabel: "Comment :",
    //plate
    newPlateName: "Additional plate costs",
    //label for sum with words
    sumWithWordsLabel: "Payment sum with words :",
    advancePaymentSumLabel: "Paid in advance sum :",
    advancePaymentVatLabel: "Paid in advance vat :",
    leftPaymentSum: "Remaining sum EUR :",
    proformaRefLabel: "Based on document ",
    proformaRefLabelMany: "Based on documents ",
    paymentDocumentText: "When making a payment, please indicate the document number :",
    creditInvoiceRefLabel: "Credit for invoice:",
    originalInvoiceAmountLabel: "Original Invoice Amount:",
    creditAmountLabel: "Credit Amount:",
    balanceAmountLabel: "Balance:",
    discountName: "Discount",
    surchargeName: "Surcharge",
    discountLabel: "Discount/Surcharge:",
    subtotalLabel: "Sum Before:",
    discountName: "Discount",
    surchargeName: "Surcharge",
  },
]
